/** CRM 下拉：香港常見地區／分區（起點、終點配對用） */
export const HK_AREA_OPTIONS: readonly { value: string; label: string }[] = [
  { value: '中西區', label: '中西區' },
  { value: '灣仔', label: '灣仔' },
  { value: '東區', label: '東區' },
  { value: '南區', label: '南區' },
  { value: '銅鑼灣', label: '銅鑼灣' },
  { value: '北角', label: '北角' },
  { value: '鰂魚涌', label: '鰂魚涌' },
  { value: '筲箕灣', label: '筲箕灣' },
  { value: '柴灣', label: '柴灣' },
  { value: '中環', label: '中環' },
  { value: '上環', label: '上環' },
  { value: '金鐘', label: '金鐘' },
  { value: '油尖旺', label: '油尖旺' },
  { value: '尖沙咀', label: '尖沙咀' },
  { value: '佐敦', label: '佐敦' },
  { value: '油麻地', label: '油麻地' },
  { value: '旺角', label: '旺角' },
  { value: '深水埗', label: '深水埗' },
  { value: '長沙灣', label: '長沙灣' },
  { value: '九龍城', label: '九龍城' },
  { value: '土瓜灣', label: '土瓜灣' },
  { value: '紅磡', label: '紅磡' },
  { value: '黃大仙', label: '黃大仙' },
  { value: '觀塘', label: '觀塘' },
  { value: '藍田', label: '藍田' },
  { value: '將軍澳', label: '將軍澳' },
  { value: '葵青', label: '葵青' },
  { value: '葵涌', label: '葵涌' },
  { value: '青衣', label: '青衣' },
  { value: '荃灣', label: '荃灣' },
  { value: '屯門', label: '屯門' },
  { value: '元朗', label: '元朗' },
  { value: '天水圍', label: '天水圍' },
  { value: '北區', label: '北區' },
  { value: '上水', label: '上水' },
  { value: '粉嶺', label: '粉嶺' },
  { value: '大埔', label: '大埔' },
  { value: '沙田', label: '沙田' },
  { value: '馬鞍山', label: '馬鞍山' },
  { value: '西貢', label: '西貢' },
  { value: '離島', label: '離島' },
  { value: '東涌', label: '東涌' },
  { value: '大嶼山', label: '大嶼山' },
  { value: '赤鱲角', label: '赤鱲角' },
  { value: '香港仔', label: '香港仔' },
  { value: '海洋公園', label: '海洋公園' },
] as const;

export const HK_AREA_VALUES: string[] = HK_AREA_OPTIONS.map((o) => o.value);
